<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="核算周期：">
                <el-date-picker v-model="searchForm.countBatch" type="month" placeholder="选择结算月份" value-format="yyyy-MM"></el-date-picker>
            </el-form-item>
            <el-form-item label="状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option value="0" label="未核算"></el-option>
                    <el-option value="1" label="已核算"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="代理商名称：">
                <el-input v-model="searchForm.agentName"  @keyup.enter.native="getMyAccountingListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getMyAccountingListHandler" icon="el-icon-search">搜索查询</el-button>
                <!-- <el-button type="success">导出Excel</el-button> -->
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  >
            <el-table-column prop="agentName" label="代理商名称" ></el-table-column>
            <el-table-column prop="countBatch" label="核算周期" width="85"></el-table-column>
            <el-table-column prop="createTime" label="核算时间" width="140"></el-table-column>
            <el-table-column prop="orderTotalNum" label="订单总数" width="100"></el-table-column>
            <el-table-column prop="backOrderNum" label="秒返订单笔数" width="100"></el-table-column>
            <el-table-column prop="noBackOrderNum" label="未秒返订单笔数" width="120"></el-table-column>
            <el-table-column prop="orderTotalPriceRmb" label="订单总额（元）" width="120"></el-table-column>
            <el-table-column prop="orderAllCommissionPriceRmb" label="总佣金（元）" width="100"></el-table-column>
            <el-table-column prop="extractableAllPriceRmb" label="总返现金额（元）" width="120"></el-table-column>
            <el-table-column prop="backAllCommissionPriceRmb" label="总秒返金额（元）" width="120"></el-table-column>
            <el-table-column prop="returnAllCommissionPriceRmb" label="总退款金额（元）" width="120"></el-table-column>
            <el-table-column prop="orderCommissionPriceRmb" label="我的佣金（元）" width="120"></el-table-column>            
            <el-table-column prop="extractablePriceRmb" label="我的返现金额（元）" width="140"></el-table-column> 
            <el-table-column prop="backCommissionPriceRmb" label="我的秒返金额（元）" width="140"></el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
    </div>
</template>
<script>
import {getMyAccountingList} from '@/api/finance.js'
import common from '@/utils/common.js'
export default {
    data() {
        return {
            searchForm: {
                countBatch: '',
                state: '',
                agentName: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            }
        }
    },
    methods: {
        getMyAccountingListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getMyAccountingList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getMyAccountingListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getMyAccountingListHandler();
        }         
    },
    created () {
        this.getMyAccountingListHandler();
    }
}
</script>
<style>

</style>